module.exports = __webpack_public_path__ + "/login_ui/img/fo-83c3d998b9a14cb00e32c32a9da0d1b4.svg";